import { render, staticRenderFns } from "./AscUserCommentListWrapper.vue?vue&type=template&id=69f7f2e2&"
import script from "./AscUserCommentListWrapper.vue?vue&type=script&lang=js&"
export * from "./AscUserCommentListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscUserCommentListWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports